import { format } from "date-fns";

export function getDateText(
  date: string | Date,
  options: { withTime?: boolean } = { withTime: false },
) {
  return format(
    date instanceof Date ? date : new Date(date),
    `yyyy-MM-dd${options?.withTime ? ", HH:mm" : ""}`,
  );
}
